import { Injectable } from '@angular/core';
import { AES } from 'crypto-es/lib/aes';
import { Utf8 } from 'crypto-es/lib/core';
import { environment } from 'src/environments/environment';
import { Deck } from '../models/deck.model';
import { Flashcard } from '../models/flashcard.model';
import { User } from '../models/user.model';
import { TimerEntry } from './timer.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private DECK_KEY = 'deck';
  private USER_KEY = 'user';
  private FLASHCARD_KEY = 'flashcard';
  private INVITE_LINK_KEY = 'inviteLink';
  private STUDY_TIME = 'StudyTimes';
  private secretKey = 'wB3FKZWR5l3SpPSb6iMIkXXr0f9JIzeK';
  private encryptLocalStorage = environment.encryptLocalStorage;

  constructor() {}

  public setDeck(deck: Deck | undefined) {
    this.setItem(this.DECK_KEY, deck);
  }

  public getDeck(): Deck | undefined {
    return this.getItem(this.DECK_KEY);
  }

  public setUser(user: User | undefined) {
    this.setItem(this.USER_KEY, user);
  }

  public getUser(): User | undefined {
    return this.getItem(this.USER_KEY);
  }

  public setStudyTime(studytime: Record<string, TimerEntry> | undefined) {
    this.setItem(this.STUDY_TIME, studytime);
  }

  public getStudyTime(): Record<string, TimerEntry> | undefined {
    return this.getItem(this.STUDY_TIME);
  }

  public setFlashcard(flashcard: Flashcard | undefined) {
    this.setItem(
      this.FLASHCARD_KEY,
      flashcard // ? flashcardConverter.toFirestore(flashcard) : undefined
    );
  }

  public getFlashcard(): Flashcard | undefined {
    return this.getItem(this.FLASHCARD_KEY) || undefined;
  }

  public setInviteLink(inviteLink: string | undefined) {
    this.setItem(this.INVITE_LINK_KEY, inviteLink);
  }

  public getInviteLink(): string | undefined {
    return this.getItem(this.INVITE_LINK_KEY);
  }

  public clear() {
    [
      this.DECK_KEY,
      this.USER_KEY,
      this.FLASHCARD_KEY,
      this.INVITE_LINK_KEY,
      this.STUDY_TIME,
    ].forEach((key) => localStorage.removeItem(key));
  }

  private setItem(key: string, value: unknown | undefined) {
    if (value === undefined) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, this.encrypt(JSON.stringify(value)));
  }

  private getItem(key: string) {
    const encValue = localStorage.getItem(key);
    if (!encValue) {
      return undefined;
    }
    const stringValue = this.decrypt(encValue);
    const value = JSON.parse(stringValue);
    return value || undefined;
  }

  private encrypt(value: string) {
    if (!this.encryptLocalStorage) {
      return value;
    }
    return AES.encrypt(value, this.secretKey).toString();
  }

  private decrypt(value: string) {
    if (!this.encryptLocalStorage) {
      return value;
    }
    const bytes = AES.decrypt(value, this.secretKey);
    return bytes.toString(Utf8);
  }
}
